import { MessageRead } from '../julia-agent-openapi/models';
import { Block } from './julia-block.model';
import { BLOCK_VIEWS } from './block-registry';

/** An answer with blocks, as the chat shows it: the text without the blocks' markdown, then the blocks. The blocks
 * come from the stream while it runs, from the message meta once saved. A message holding a block no component
 * shows, or whose blocks expired, keeps its whole markdown. */
export class MessageBlocks {

  static blocks(message: MessageRead & { blocks?: Block[]; blocksExpired?: boolean }): Block[] {
    if (message.blocksExpired) return [];
    const blocks: Block[] = message.blocks ?? message.meta?.['blocks'] ?? [];
    return blocks.length && blocks.every(b => !!BLOCK_VIEWS[b.kind]) ? blocks : [];
  }

  static text(message: MessageRead & { blocks?: Block[] }): string {
    const content = message.content ?? '';
    const span = MessageBlocks.span(message);
    if (!span || !MessageBlocks.blocks(message).length) return content;
    return (content.slice(0, span[0]) + content.slice(span[1])).trim();
  }

  private static span(message: MessageRead & { blocks?: Block[] }): [number, number] | null {
    const meta = message.meta ?? {};
    const first = message.blocks?.[0];
    const from = first?.tables_from ?? meta['tables_from'];
    const to = first?.tables_to ?? meta['tables_to'] ?? message.content?.length;
    return typeof from === 'number' && typeof to === 'number' ? [from, to] : null;
  }
}
